import React, { useContext, useState } from "react";
import styled, { css, keyframes } from "styled-components";
import { Redirect } from "react-router";

import UIManager from "../../service/ui-manager";
import AuthService from "../../service/auth";
import { AccountContext } from "../../provider/account";
import { Text, Gap, Img, Box, Button, Row, Col } from "../../comps";
import { NAVBAR } from "../../theme/dimensions";
import { Theme } from "../../theme/theme-provider";

import avatarImg from "../../theme/assets/image/avatar.png";
import { faSignInAlt, faSignOutAlt } from "@fortawesome/free-solid-svg-icons";

const slideInRight = keyframes`
  0% { margin-left:${NAVBAR.FULL_WIDTH - NAVBAR.SIDE_WIDTH}px; }
  100% { margin-left:0px; }
`;

const hidden = keyframes`
  0% { opacity:0; }
  /* 99% { opacity:0;} */
  100% { opacity:0; }
`;

const Wrapper = styled(Col)`
  width: 100%;
  height: 100%;
  padding-left: 5px;
  padding-right: 5px;
  /* items centered in column */
  align-items: center;
`;

const OptionItem = styled(Row)`
  width: 100%;
  height: 50px;
  align-items: center;
  padding-left: 5px;
  padding-right: 5px;
  justify-content: space-between;
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.color.BLACK_3};
  }
`;

const SmallIcon = styled(Img)`
  width: ${({ width }) => width + "px"};
  height: ${({ height }) => (height ? height + "px" : `auto`)};
  box-sizing: border-box;
  ${(props) => {
    return (
      props.opacity &&
      css`
        opacity: ${props.opacity};
      `
    );
  }}
  ${OptionItem}:hover & {
    opacity: 1;
  }
`;

const AnimatedOptionItem = styled(OptionItem)`
  opacity: 1;
  animation: ${({ delay }) => (delay ? delay + "s" : "")} ${hidden} linear,
    0.2s ${({ delay }) => (delay ? delay + "s" : "")} ${slideInRight} linear;
`;

const TextContainer = styled(Row)`
  height: 24px;
  margin-top: 12px;
  margin-bottom: 5px;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 3px;
  font-size: 14px;
  text-align: center;
  align-items: center;
  color: ${({ theme }) => theme.textColor.light};
  background: ${({ theme }) => theme.color.GRAY_2};
  border-radius: 20px;
`;

export default () => {
  const [userInfo] = useContext(AccountContext);
  const [redirectTo, setRedirect] = useState("");
  const { username, isLoggedIn, profile } = userInfo;

  const handleLogout = () => {
    AuthService.logout();
  };

  const handleLogin = () => {
    setRedirect("/auth");
    UIManager.collapsePlayer();
  };

  const viewProfile = () => {
    setRedirect("/account");
    UIManager.collapsePlayer();
  };

  const getDelay = (pos) => ((pos + 1) * 1.0) / 10;

  return (
    <Wrapper>
      <Img
        style={{ opacity: 0.9, marginTop: "20px", cursor: "pointer" }}
        src={(profile && profile.imageUrl) || avatarImg}
        round={profile && profile.imageUrl && true}
        width={"54%"}
        alt="image"
        onClick={viewProfile}
      />
      <TextContainer>{isLoggedIn ? username : "please Login"}</TextContainer>
      <Col style={{ width: "100%", marginTop: "30px" }}>
        <AnimatedOptionItem delay={getDelay(0)} key={0}>
          <Row
            style={{
              width: "100%",
              height: "100%",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              width="90%"
              height="60%"
              buttonTextColor={Theme.textColor.light}
              buttonBackground={Theme.color.RED_6}
              buttonName={isLoggedIn ? "Logout" : "Login"}
              buttonIcon={isLoggedIn ? faSignOutAlt : faSignInAlt}
              buttonFontSize="14px"
              borderRadius={5}
              onClick={isLoggedIn ? handleLogout : handleLogin}
            />
          </Row>
        </AnimatedOptionItem>
        {redirectTo && <Redirect push to={redirectTo} />}
      </Col>
    </Wrapper>
  );
};
